import { useState } from "react";

const useFormFields = (initialState) => {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    (event) => {
      const newValues = {
        ...fields,
        [event.target.id]:
          event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value,
      };
      setValues(newValues);
    },
  ];
};

export default useFormFields;
